// extracted by mini-css-extract-plugin
export default {"cardContainer":"styles_cardContainer__55W4K","popup":"styles_popup__eF5la"};